import axios from 'axios';
import authHeader from './auth-header';
import Config from '../config/index';

class PostService {
    async saveNewPost(data) {
        const response = await axios.post(Config.apiBasePath + '/saveElement', data, {headers: authHeader()});
        return response;
    }

    async updatePost(data) {
        const response = await axios.post(Config.apiBasePath + '/updateElement', data, {headers: authHeader()});
        return response;
    }

    async getPostsByCategoryId(data) {
        const response = await axios.get(Config.apiBasePath + '/getElements/' + data, {headers: authHeader()});
        return response;
    }

    async getPaginatedPostsByCategoryId(categoryId, param) {
        // const response = await axios.get(Config.apiBasePath + '/getElementsWithFilter/' + categoryId, { headers: authHeader(), params: param });
        const response = await axios.post(Config.apiBasePath + '/getElementsWithFilter/' + categoryId, null, {
            headers: authHeader(),
            params: param
        });
        // const response = await axios.post('http://192.168.78.44:9008/cms/api/v1/getElementsWithFilter/' + categoryId, null, { headers: authHeader(), params: param });
        return response;
    }

    async getPostRevisions(postId) {
        const response = await axios.get(Config.apiBasePath + '/getElementRevisions?id=' + postId, {headers: authHeader()});
        return response;
    }

    async getPostByElementId(data) {
        const response = await axios.get(Config.apiBasePath + '/getSingleElement/' + data, {headers: authHeader()});
        return response;
    }

    async deletePost(data) {
        const response = await axios.get(Config.apiBasePath + '/deleteElement/' + data, {headers: authHeader()});
        return response;
    }

    async revertPost(data) {
        const response = await axios.get(Config.apiBasePath + '/revertElement/' + data, {headers: authHeader()});
        return response;
    }

    async permanentDeleteEle(data) {
        const response = await axios.delete(Config.apiBasePath + '/permanentDeleteElement/' + data, {headers: authHeader()});
        return response;
    }

    async deleteFileMapping(param) {
        const response = await axios.get(Config.apiBasePath + '/deleteFileMapping',
            {headers: authHeader(), params: param});
        return response;
    }

}

export default new PostService();
